export default __webpack_public_path__ + "f245f3d89a0196f8b0119f3b2d3173be.woff";